// extracted by mini-css-extract-plugin
export default {"playerWrapper":"styles_playerWrapper__TSsjS","playerWrapper__error":"styles_playerWrapper__error__v3yua","playerWrapper__frame":"styles_playerWrapper__frame__PiGz4"};